import api from './client';

export interface OfferPoolSyncReport {
  added: string[];
  removed: string[];
  flows_created: number;
  offers_attached: number;
  offers_detached: number;
  flows_removed: number;
}

export const getOfferPoolCampaigns = (offerId: string) =>
  api.get<string[]>(`/admin/tracker/offer-pools/offer/${offerId}`);

export const syncOfferPoolCampaigns = (offerId: string, campaign_ids: string[]) =>
  api.put<OfferPoolSyncReport>(`/admin/tracker/offer-pools/offer/${offerId}`, { campaign_ids });

export interface OfferPoolCoverageRow {
  offer_id: string;
  geo_count: number;
  campaign_ids: string[];
}

/** Every active offer with the pool campaigns it is attached to. */
export const getOfferPoolCoverage = () =>
  api.get<OfferPoolCoverageRow[]>('/admin/tracker/offer-pools/offer/coverage');

export interface OfferPoolAttachReport {
  offers_processed: number;
  offers_attached: number;
  flows_created: number;
  errors: string[];
}

/** Add offers to pool campaigns in bulk; never detaches anything. */
export const attachOfferPools = (items: Array<{ offer_id: string; campaign_ids: string[] }>) =>
  api.post<OfferPoolAttachReport>('/admin/tracker/offer-pools/offer/attach', { items });
